import { z } from 'zod'
import { managerBenefitClassTypeSchema } from './manager-benefit-class-type'

/** 禮遇項目 - 共用欄位 Schema */
export const managerBenefitCommonSchema = z
  .object({
    /** 項目名稱[英文] */
    englishName: z.string(),
    /** 項目名稱[簡體中文] */
    simplifiedName: z.string(),
    /** 項目名稱[繁體中文] */
    traditionalName: z.string()
  })
  .merge(managerBenefitClassTypeSchema)

/** 禮遇項目 - 共用欄位 */
export interface ManagerBenefitCommon
  extends z.infer<typeof managerBenefitCommonSchema> {}
